<footer id="footer" class="footer sec-padding">
  <div class="container fx-row fx-main-center fx-cross-center">
    <div class="footer-wrapper fx-row-wrap fx-main-center fx-cross-start fx-flex-85">
      <div class="footer-widget about-widget fx-flex-100 sm-fx-flex-50-in-wrap gt-sm-fx-flex-30-in-wrap">
        <p><span class="c-black logo cursor-pointer">ThinkEnergy</span></p>
      </div>
      <div [appBreakpointClass]="{'sm':'mt-2','xs':'mt-2'}"
        class="footer-widget subscribe-widget fx-flex-100 sm-fx-flex-50-in-wrap gt-sm-fx-flex-23-in-wrap">
        <div class="title">
          <h5 [translate]="'contact_us'">Contact Us</h5>
        </div>
        <div class="tel-box fx-row">
          <div class="icon"><i class="fa fa-map-marker"></i></div>
          <div class="text">
            <p>
              {{footerContactInformation.Address1}}
              {{footerContactInformation.City}}
              {{footerContactInformation.State}}
            {{configService.localSettings.Company.Address.Country}}</p>
          </div>
        </div>
        @if (footerContactInformation.Phone != null) {
          <div class="tel-box fx-row">
            <div class="icon"><i class="fa fa-phone"></i></div>
            <div class="text">
              <p>{{footerContactInformation.Phone}}</p>
            </div>
          </div>
        }
        <div class="tel-box fx-row">
          <div class="icon"><i class="fa fa-envelope"></i></div>
          <div class="text">
            <p><a>{{configService.localSettings.Company.Address.Email}}</a></p>
          </div>
        </div>

        <ul class="social list-inline fx-row">
          @for (sociallink of configService.localSettings.Company.SocialLinks; track sociallink) {
            <li><a [href]="sociallink.link"
              target="_blank"><i [class]="sociallink.icon"></i></a></li>
            }
          </ul>
        </div>
      </div>
    </div>
  </footer>